import { render, staticRenderFns } from "./KanbanCard.vue?vue&type=template&id=935b53c2&scoped=true&"
import script from "./KanbanCard.vue?vue&type=script&lang=js&"
export * from "./KanbanCard.vue?vue&type=script&lang=js&"
import style0 from "./KanbanCard.vue?vue&type=style&index=0&id=935b53c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935b53c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('935b53c2')) {
      api.createRecord('935b53c2', component.options)
    } else {
      api.reload('935b53c2', component.options)
    }
    module.hot.accept("./KanbanCard.vue?vue&type=template&id=935b53c2&scoped=true&", function () {
      api.rerender('935b53c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/management/KanbanCard.vue"
export default component.exports